export const USER_ROLE_NAMES = {
    ADMIN_PROVIDER: 'Provider Admin',
    PROVIDER: 'Provider',
    BILLER: 'Biller',
    FRONT_DESK:'Front Desk'
}